import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const Menu = styled("div")({
  padding: "26px 28px",
});

export const Close = styled(Box)({
  marginBottom: 20,
});
